enum BreadcrumbEventNames {
  PAGE_VIEW = 'PAGE_VIEW',
}

export default BreadcrumbEventNames;
